module.exports = __webpack_public_path__ + "static/media/Primarina_gaussian2.3f9b3f7e.png";